export default {
	"7e6ab2d092cae882333d720712140a43": "In-app purchase items have expired"
}
